<script lang="ts">
    import Label from "./Label.svelte";
    import {slide} from "svelte/transition";

    let {
        id,
        placeholder = '',
        type = 'text',
        label,
        value = $bindable(),
        required = false,
        error = null,
    }: {
        id?: string;
        placeholder?: string;
        type?: string;
        label?: string;
        value: string;
        required?: boolean;
        error?: string | null;
    } = $props();

    let dirty = $state(false);

    let showError = $derived(dirty && error);
</script>

<div class="flex flex-col justify-end"
     class:input-has-error={showError}
>
    {#if label}
        <Label {id} {label}/>
    {/if}
    <input
            id={id}
            class="w-full rounded-xl p-3 shadow-sm"
            bind:value
            {placeholder}
            {type}
            {required}
            onblur={() => dirty = true}
    />
    {#if showError}
        <p
                transition:slide={{axis:'y', duration: 200}}
                class="mt-1 text-sm text-red-500"
        >{error}</p>
    {/if}
</div>


<style>
    @import "tailwindcss";

    input {
        border: 1px solid #CDB6E2;
        outline: none !important;
        font-size: 14px;
    }

    input:focus {
        border-color: #A78BFA;
        box-shadow: 0 0 0 2px rgba(167, 139, 250, 0.5);
    }
</style>
